var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mod__downloads" }, [
    !_vm.hideNavigation
      ? _c(
          "div",
          {
            staticClass: "side__menu mod__downloads--navigation",
            class: { "is--open": _vm.menuOpen },
          },
          [
            _c(
              "div",
              {
                staticClass: "side__menu-close",
                attrs: { "data-dismiss": "modal", "aria-label": "Close" },
                on: {
                  click: function ($event) {
                    return _vm.toggleResponsiveMenu()
                  },
                },
              },
              [_c("i", { staticClass: "icon-ui-menu-hide pe-none" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "side__menu-header" }, [
              _c("span", [_vm._v(" " + _vm._s(_vm.labels.menu))]),
            ]),
            _vm._v(" "),
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "loading--container loader--center" },
                  [_vm._m(0)]
                )
              : _c("download-menu", {
                  ref: "menu",
                  staticClass: "side__menu-content",
                  attrs: {
                    item: _vm.menu,
                    children: _vm.menu.children,
                    depth: 0,
                  },
                }),
            _vm._v(" "),
            _c("div", { staticClass: "side__menu-footer" }, [
              _c(
                "button",
                {
                  staticClass: "show-all active",
                  on: {
                    click: function ($event) {
                      return _vm.setAllButtonActive($event)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.allMenuButton.label))]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "mod__downloads--container",
        class: [_vm.hideNavigation ? "full" : ""],
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isContentLoading,
                expression: "isContentLoading",
              },
            ],
            staticClass: "loading--container loader--center",
          },
          [_vm._m(1)]
        ),
        _vm._v(" "),
        _c("download-content", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isContentLoading,
              expression: "!isContentLoading",
            },
          ],
          attrs: {
            labels: _vm.labels,
            items: _vm.items,
            "default-view": _vm.defaultView,
          },
          on: { "toggle-menu": _vm.toggleResponsiveMenu },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "spinner-border text-secondary",
        attrs: { role: "status" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border text-primary", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }